(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["el-table-horizontal-scroll"] = factory();
	else
		root["el-table-horizontal-scroll"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 